import Gigya, { BaseParams } from './gigya.js'
import GigyaResponse from './interfaces/gigya-response.js'

export type GetAllParams = {
	context: Record<string, any>
}

export const WebhookEvents = [
	'organizationRequested',
	'organizationEnteredDraftStage',
	'organizationEnteredApprovalWorkflow',
	'organizationActivated',
	'organizationSuspended',
	'organizationRejected',
	'organizationWorkflowEnabled',
	'organizationApprovalRequest_FinalStage_external'
] as const

type WebhookEventsType = (typeof WebhookEvents)[number]

export type GetAllResponse = {
	Webhook: {
		name: string
		events: WebhookEventsType[]
		webhookToken: string
	}[]
}

export class AccountsB2bWebhooks {
	constructor(protected gigya: Gigya) {}

	public getAll(params: BaseParams & GetAllParams) {
		return this.gigya.request<GigyaResponse & GetAllResponse>(
			'accounts.b2b.webhooks.getAll',
			params
		)
	}
}
